<template>
  <WhatTypeOfFramesField
    field="custom-dimension-4"
    :choices="choices"
    v-on="$listeners"
  />
</template>

<script>
import WhatTypeOfFramesField from 'chimera/all/components/form/fields/typeOfWork/TypeOfWorkField'
import { Selectable } from 'chimera/all/components/models/Selectable'

export default {
  name: 'WhatTypeOfFramesFormPart',

  components: {
    WhatTypeOfFramesField,
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      choices: [
        new Selectable('Ramen', 'Ramen', 'Ramen'),
        new Selectable('Deuren', 'Deuren', 'Deuren'),
        new Selectable('Ramen en deuren', 'Ramen en deuren', 'Ramen en deuren'),
        new Selectable('Andere', 'Andere', 'Andere'),
      ],
    }
  },
}
</script>
